// Royalty-free arcade SFX, synthesized with the Web Audio API (no asset hosting needed).
// Mirrors the DuckHunt beep approach. Mute preference is remembered in localStorage.
const MUTE_KEY = "goldys.candy_muted";

let ctx = null;
function audio() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export const isMuted = () => {
  try { return localStorage.getItem(MUTE_KEY) === "1"; } catch { return false; }
};
export const setMuted = (v) => {
  try { localStorage.setItem(MUTE_KEY, v ? "1" : "0"); } catch { /* ignore */ }
};

function tone({ freq = 440, type = "sine", dur = 0.12, gain = 0.14, slideTo = null, delay = 0 }) {
  const ac = audio();
  if (!ac) return;
  const t0 = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g); g.connect(ac.destination);
  osc.start(t0); osc.stop(t0 + dur + 0.02);
}

export const sfx = {
  swap: () => { if (isMuted()) return; tone({ freq: 520, type: "triangle", dur: 0.08, gain: 0.1 }); },
  invalid: () => { if (isMuted()) return; tone({ freq: 180, type: "sawtooth", dur: 0.16, gain: 0.08, slideTo: 110 }); },
  // combo: higher pitch + brighter for longer cascade chains
  match: (combo = 1) => {
    if (isMuted()) return;
    const base = 440 + Math.min(combo - 1, 6) * 80;
    tone({ freq: base, type: "triangle", dur: 0.1, gain: 0.13 });
    if (combo > 1) tone({ freq: base * 1.5, type: "sine", dur: 0.12, gain: 0.1, delay: 0.05 });
  },
  reshuffle: () => { if (isMuted()) return; tone({ freq: 300, type: "sine", dur: 0.3, gain: 0.1, slideTo: 760 }); },
  finish: () => {
    if (isMuted()) return;
    [523, 659, 784, 1046].forEach((f, i) => tone({ freq: f, type: "triangle", dur: 0.16, gain: 0.12, delay: i * 0.1 }));
  },
};
